<template>
  <div class="page-callback">
    <div class="title-callback">
      <pageTitle :pageTitle="$t('lang.k_341001')">
        <span v-if="isShowTip" class="title-callback-tip">{{ $t('lang.k_341002') }}</span>
      </pageTitle>
      <a href="https://saas-doc.vhall.com/opendocs/show/1163" target="_blank">
        {{ $t('lang.k_341003') }}
      </a>
    </div>
    <div class="layout-callback">
      <section class="cate_card">
        <h3 class="cate_name">{{ $t('lang.k_341004') }}</h3>
        <div class="cate_content">
          <vh-form :model="form" ref="form" :rules="formRules" label-width="102px">
            <vh-form-item :label="$t('lang.k_341005')" prop="secret_key">
              <vh-input
                v-model.trim="form.secret_key"
                v-clearEmoij
                autocomplete="off"
                :placeholder="$t('lang.k_341006')"
                :maxlength="32"
                show-word-limit
              ></vh-input>
            </vh-form-item>
            <vh-form-item :label="$t('lang.k_341007')" prop="callback_url">
              <vh-input
                v-model.trim="form.callback_url"
                v-clearEmoij
                autocomplete="off"
                :placeholder="$t('lang.k_341008')"
                :maxlength="255"
                show-word-limit
              ></vh-input>
            </vh-form-item>
            <vh-form-item
              :label="$t('lang.k_341009')"
              prop="msg_type"
              class="radio-btn"
              label-width="102px"
            >
              <vh-radio-group v-model="form.msg_type">
                <vh-radio :label="1">application/x-www-form-urlencoded</vh-radio>
                <vh-radio :label="2">application/json</vh-radio>
              </vh-radio-group>
            </vh-form-item>
          </vh-form>
          <div class="div__view">
            <ul class="switch__list">
              <li class="switch__box">
                <label class="leve3_title label__r12">{{ $t('lang.k_341010') }}</label>
                <vh-switch
                  v-model="form.fail_try_request"
                  :active-value="1"
                  :inactive-value="0"
                  active-color="#FB3A32"
                  inactive-color="#CECECE"
                ></vh-switch>
                <span class="leve3_title title--999">
                  {{ !!form.fail_try_request ? $t('lang.k_341011') : $t('lang.k_341012') }}
                </span>
                &nbsp;
                <vh-tooltip effect="dark" placement="right" v-tooltipMove>
                  <div slot="content">
                    <span>{{ $t('lang.k_341013') }}</span>
                    <br />
                    <p style="width: 400px">{{ $t('lang.k_341014') }}</p>
                  </div>
                  <i class="iconfont-v3 saasicon_help_m"></i>
                </vh-tooltip>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section class="cate_card" v-for="(item, index) in keyList" :key="index">
        <h3 class="cate_name">{{ item.title }}</h3>
        <div class="cate_content div__view">
          <ul class="switch__list">
            <li class="switch__box" v-for="(el, ins) in item.list" :key="`view_` + ins">
              <label class="leve3_title label__r12">{{ el.key_name }}</label>
              <vh-switch
                v-model="el.value"
                :active-value="1"
                :inactive-value="0"
                active-color="#FB3A32"
                inactive-color="#CECECE"
              ></vh-switch>
              <span class="leve3_title title--999">
                {{ !!el.value ? el.closeShow : el.openShow }}
              </span>
            </li>
          </ul>
        </div>
      </section>
      <vh-form label-width="91px">
        <vh-form-item label="" class="callback-btn">
          <vh-button
            type="primary"
            class="length152"
            v-preventReClick
            round
            @click.prevent.stop="saveCallbackInfo"
          >
            {{ $t('lang.k_341015') }}
          </vh-button>
        </vh-form-item>
      </vh-form>
    </div>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle';
  import { sessionOrLocal } from '@/utils/utils';
  export default {
    name: 'callback.vue',
    components: {
      PageTitle
    },
    data() {
      return {
        callbackVo: {},
        isAdd: null,
        form: {
          secret_key: null,
          callback_url: null,
          msg_type: null,
          fail_try_request: 0
        },
        formRules: {
          secret_key: [{ required: true, message: this.$t('lang.k_341006'), trigger: 'blur' }],
          callback_url: [
            { required: true, message: this.$t('lang.k_341008'), trigger: 'blur' },
            {
              pattern: /(http|https):\/\/[\w\-_]+(\.[\w\-_]+).*?/,
              message: this.$t('lang.k_341008'),
              trigger: 'blur'
            }
          ],

          msg_type: [{ required: true, message: this.$t('lang.k_341016'), trigger: 'blur' }]
        },
        keyList: [],
        isShowTip: false // 是否显示 回调文本 tip
      };
    },
    created() {
      this.userId = this.$route.query.userId;
      this.getCallbackInfo();
      // 设置是否显示 回调文本 tip
      this.setIsShowTip();
    },
    methods: {
      getCallbackInfo() {
        let eventsList = [];
        this.$fetch('getCallbackInfo', {})
          .then(res => {
            if (res && res.code === 200 && res.data) {
              // 若无内容，默认展示
              if (res.data && !res.data.msg_type) {
                res.data.msg_type = 1;
              }
              if (res.data && !res.data.fail_try_request) {
                res.data.fail_try_request = 0;
              }
              this.form = res.data;
              // this.form.callback_type = 1;
              eventsList = (res.data?.callback_event || '').split(',');
            } else {
              this.form = {
                secret_key: null,
                callback_url: null
              };
            }
            this.isAdd = !(res.data && res.data.id);
            let keyList = [
              {
                title: this.$t('lang.k_341017'),
                list: [
                  {
                    type: 'key_10',
                    key_name: this.$t('lang.k_341018'),
                    openShow: this.$t('lang.k_341019'),
                    closeShow: this.$t('lang.k_341020'),
                    value: Number(eventsList.includes('10') ? 1 : 0) || 0,
                    k: 100841
                  },
                  {
                    type: 'key_40',
                    key_name: this.$t('lang.k_341021'),
                    openShow: this.$t('lang.k_341022'),
                    closeShow: this.$t('lang.k_341023'),
                    value: Number(eventsList.includes('40') ? 1 : 0) || 0,
                    k: ''
                  },
                  {
                    type: 'key_41',
                    key_name: this.$t('lang.k_341024'),
                    openShow: this.$t('lang.k_341025'),
                    closeShow: this.$t('lang.k_341026'),
                    value: Number(eventsList.includes('41') ? 1 : 0) || 0,
                    k: ''
                  }
                ]
              },
              {
                title: this.$t('lang.k_341027'),
                list: [
                  {
                    type: 'key_1',
                    key_name: this.$t('lang.k_341027'),
                    openShow: this.$t('lang.k_341028'),
                    closeShow: this.$t('lang.k_341029'),
                    value: Number(eventsList.includes('1') ? 1 : 0) || 0,
                    k: 100601
                  },
                  {
                    type: 'key_14',
                    key_name: this.$t('lang.k_341030'),
                    openShow: this.$t('lang.k_341031'),
                    closeShow: this.$t('lang.k_341032'),
                    value: Number(eventsList.includes('14') ? 1 : 0) || 0,
                    k: 100852
                  },
                  {
                    type: 'key_13',
                    key_name: this.$t('lang.k_341033'),
                    openShow: this.$t('lang.k_341034'),
                    closeShow: this.$t('lang.k_341035'),
                    value: Number(eventsList.includes('13') ? 1 : 0) || 0,
                    k: 100850
                  },
                  {
                    type: 'key_11',
                    key_name: this.$t('lang.k_341036'),
                    openShow: this.$t('lang.k_341037'),
                    closeShow: this.$t('lang.k_341037'),
                    value: Number(eventsList.includes('11') ? 1 : 0) || 0,
                    k: 100843
                  }
                ]
              },
              {
                title: this.$t('lang.k_341038'),
                list: [
                  {
                    type: 'key_4',
                    key_name: this.$t('lang.k_341039'),
                    openShow: this.$t('lang.k_341040'),
                    closeShow: this.$t('lang.k_341041'),
                    value: Number(eventsList.includes('4') ? 1 : 0) || 0,
                    k: 100603
                  },
                  {
                    type: 'key_8',
                    key_name: this.$t('lang.k_341042'),
                    openShow: this.$t('lang.k_341043'),
                    closeShow: this.$t('lang.k_341044'),
                    value: Number(eventsList.includes('8') ? 1 : 0) || 0,
                    k: 100605
                  },
                  {
                    type: 'key_5',
                    key_name: this.$t('lang.k_341045'),
                    openShow: this.$t('lang.k_341046'),
                    closeShow: this.$t('lang.k_341047'),
                    value: Number(eventsList.includes('5') ? 1 : 0) || 0,
                    k: 100607
                  },
                  {
                    type: 'key_6',
                    key_name: this.$t('lang.k_341048'),
                    openShow: this.$t('lang.k_341049'),
                    closeShow: this.$t('lang.k_341050'),
                    value: Number(eventsList.includes('6') ? 1 : 0) || 0,
                    k: 100609
                  },
                  {
                    type: 'key_9',
                    key_name: this.$t('lang.k_341051'),
                    openShow: this.$t('lang.k_341052'),
                    closeShow: this.$t('lang.k_341053'),
                    value: Number(eventsList.includes('9') ? 1 : 0) || 0,
                    k: 100848
                  }
                ]
              },
              {
                title: this.$t('lang.k_341054'),
                list: [
                  {
                    type: 'key_3',
                    key_name: this.$t('lang.k_341055'),
                    openShow: this.$t('lang.k_341056'),
                    closeShow: this.$t('lang.k_341057'),
                    value: Number(eventsList.includes('3') ? 1 : 0) || 0,
                    k: 100611
                  },
                  {
                    type: 'key_7',
                    key_name: this.$t('lang.k_341058'),
                    openShow: this.$t('lang.k_341059'),
                    closeShow: this.$t('lang.k_341060'),
                    value: Number(eventsList.includes('7') ? 1 : 0) || 0,
                    k: 100613
                  },
                  {
                    type: 'key_38',
                    key_name: this.$t('lang.k_341061'),
                    openShow: this.$t('lang.k_341062'),
                    closeShow: this.$t('lang.k_341063'),
                    value: Number(eventsList.includes('38') ? 1 : 0) || 0,
                    k: ''
                  }
                ]
              },
              {
                title: this.$t('lang.k_341064'),
                list: [
                  {
                    type: 'key_15',
                    key_name: this.$t('lang.k_341065'),
                    openShow: this.$t('lang.k_341066'),
                    closeShow: this.$t('lang.k_341067'),
                    value: Number(eventsList.includes('15') ? 1 : 0) || 0,
                    k: 100854
                  }
                ]
              },
              {
                title: this.$t('lang.k_341068'),
                list: [
                  {
                    type: 'key_26',
                    key_name: this.$t('lang.k_341069'),
                    openShow: this.$t('lang.k_341070'),
                    closeShow: this.$t('lang.k_341071'),
                    value: Number(eventsList.includes('26') ? 1 : 0) || 0,
                    k: 100860
                  },
                  {
                    type: 'key_21',
                    key_name: this.$t('lang.k_341072'),
                    openShow: this.$t('lang.k_341073'),
                    closeShow: this.$t('lang.k_341074'),
                    value: Number(eventsList.includes('21') ? 1 : 0) || 0,
                    k: 100861
                  },
                  {
                    type: 'key_22',
                    key_name: this.$t('lang.k_341075'),
                    openShow: this.$t('lang.k_341076'),
                    closeShow: this.$t('lang.k_341077'),
                    value: Number(eventsList.includes('22') ? 1 : 0) || 0,
                    k: 100862
                  },
                  {
                    type: 'key_23',
                    key_name: this.$t('lang.k_341078'),
                    openShow: this.$t('lang.k_341079'),
                    closeShow: this.$t('lang.k_341080'),
                    value: Number(eventsList.includes('23') ? 1 : 0) || 0,
                    k: 100863
                  },
                  {
                    type: 'key_24',
                    key_name: this.$t('lang.k_341081'),
                    openShow: this.$t('lang.k_341082'),
                    closeShow: this.$t('lang.k_341083'),
                    value: Number(eventsList.includes('24') ? 1 : 0) || 0,
                    k: 100864
                  },
                  {
                    type: 'key_25',
                    key_name: this.$t('lang.k_341084'),
                    openShow: this.$t('lang.k_341085'),
                    closeShow: this.$t('lang.k_341086'),
                    value: Number(eventsList.includes('25') ? 1 : 0) || 0,
                    k: 100865
                  }
                ]
              },
              {
                title: this.$t('lang.k_341087'),
                list: [
                  {
                    type: 'key_30',
                    key_name: this.$t('lang.k_341088'),
                    openShow: this.$t('lang.k_341089'),
                    closeShow: this.$t('lang.k_341090'),
                    value: Number(eventsList.includes('30') ? 1 : 0) || 0,
                    k: 100866
                  }
                ]
              },
              {
                title: this.$t('lang.k_341091'),
                list: [
                  {
                    type: 'key_35',
                    key_name: this.$t('lang.k_341092'),
                    openShow: this.$t('lang.k_341093'),
                    closeShow: this.$t('lang.k_341094'),
                    value: Number(eventsList.includes('35') ? 1 : 0) || 0,
                    k: 100867
                  },
                  {
                    type: 'key_3510',
                    key_name: this.$t('lang.k_341095'),
                    openShow: this.$t('lang.k_341096'),
                    closeShow: this.$t('lang.k_341097'),
                    value: Number(eventsList.includes('3510') ? 1 : 0) || 0,
                    k: 100868
                  },
                  {
                    type: 'key_3520',
                    key_name: this.$t('lang.k_341098'),
                    openShow: this.$t('lang.k_341099'),
                    closeShow: this.$t('lang.k_341100'),
                    value: Number(eventsList.includes('3520') ? 1 : 0) || 0,
                    k: 100869
                  },
                  {
                    type: 'key_3530',
                    key_name: this.$t('lang.k_341101'),
                    openShow: this.$t('lang.k_341102'),
                    closeShow: this.$t('lang.k_341103'),
                    value: Number(eventsList.includes('3530') ? 1 : 0) || 0,
                    k: 100870
                  },
                  {
                    type: 'key_3540',
                    key_name: this.$t('lang.k_341104'),
                    openShow: this.$t('lang.k_341105'),
                    closeShow: this.$t('lang.k_341106'),
                    value: Number(eventsList.includes('3540') ? 1 : 0) || 0,
                    k: 100871
                  },
                  {
                    type: 'key_3550',
                    key_name: this.$t('lang.k_341107'),
                    openShow: this.$t('lang.k_341108'),
                    closeShow: this.$t('lang.k_341109'),
                    value: Number(eventsList.includes('3550') ? 1 : 0) || 0,
                    k: 100872
                  }
                ]
              },
              {
                title: this.$t('lang.k_341110'),
                list: [
                  {
                    type: 'key_50',
                    key_name: this.$t('lang.k_341111'),
                    openShow: this.$t('lang.k_341112'),
                    closeShow: this.$t('lang.k_341113'),
                    value: Number(eventsList.includes('50') ? 1 : 0) || 0
                  }
                ]
              },
              {
                title: this.$t('lang.k_341114'),
                list: [
                  {
                    type: 'key_60',
                    key_name: this.$t('lang.k_341115'),
                    openShow: this.$t('lang.k_341116'),
                    closeShow: this.$t('lang.k_341117'),
                    value: Number(eventsList.includes('60') ? 1 : 0) || 0
                  },
                  {
                    type: 'key_61',
                    key_name: this.$t('lang.k_341118'),
                    openShow: this.$t('lang.k_341119'),
                    closeShow: this.$t('lang.k_341120'),
                    value: Number(eventsList.includes('61') ? 1 : 0) || 0
                  },
                  {
                    type: 'key_65',
                    key_name: this.$t('lang.k_341121'),
                    openShow: this.$t('lang.k_341122'),
                    closeShow: this.$t('lang.k_341123'),
                    value: Number(eventsList.includes('65') ? 1 : 0) || 0
                  }
                ]
              },
              {
                title: this.$t('lang.k_341124'),
                list: [
                  {
                    type: 'key_70',
                    key_name: this.$t('lang.k_341125'),
                    openShow: this.$t('lang.k_341126'),
                    closeShow: this.$t('lang.k_341127'),
                    value: Number(eventsList.includes('70') ? 1 : 0) || 0
                  }
                ]
              },
              {
                title: this.$t('lang.k_341128'),
                list: [
                  {
                    type: 'key_80',
                    key_name: this.$t('lang.k_341129'),
                    openShow: this.$t('lang.k_341130'),
                    closeShow: this.$t('lang.k_341131'),
                    value: Number(eventsList.includes('80') ? 1 : 0) || 0
                  }
                ]
              }
            ];

            if (this.$store.state.permissionValue['im_join_leave_msg_callback'] == 1) {
              keyList.push({
                title: this.$t('lang.k_341132'),
                list: [
                  {
                    type: 'key_20',
                    key_name: this.$t('lang.k_341133'),
                    openShow: this.$t('lang.k_341134'),
                    closeShow: this.$t('lang.k_341135'),
                    value: Number(eventsList.includes('20') ? 1 : 0) || 0
                  }
                ]
              });
            }

            this.keyList = keyList;
          })
          .catch(e => {
            console.log(e);
            this.form = {
              secret_key: null,
              callback_url: null
            };
            this.keyList = [
              {
                title: this.$t('lang.k_341017'),
                list: [
                  {
                    type: 'key_10',
                    key_name: this.$t('lang.k_341018'),
                    openShow: this.$t('lang.k_341019'),
                    closeShow: this.$t('lang.k_341020'),
                    value: 0
                  },
                  {
                    type: 'key_40',
                    key_name: this.$t('lang.k_341021'),
                    openShow: this.$t('lang.k_341022'),
                    closeShow: this.$t('lang.k_341023'),
                    value: 0
                  },
                  {
                    type: 'key_41',
                    key_name: this.$t('lang.k_341024'),
                    openShow: this.$t('lang.k_341025'),
                    closeShow: this.$t('lang.k_341026'),
                    value: 0
                  }
                ]
              },
              {
                title: this.$t('lang.k_341027'),
                list: [
                  {
                    type: 'key_1',
                    key_name: this.$t('lang.k_341027'),
                    openShow: this.$t('lang.k_341028'),
                    closeShow: this.$t('lang.k_341029'),
                    value: 0
                  },
                  {
                    type: 'key_14',
                    key_name: this.$t('lang.k_341030'),
                    openShow: this.$t('lang.k_341031'),
                    closeShow: this.$t('lang.k_341032'),
                    value: 0
                  },
                  {
                    type: 'key_13',
                    key_name: this.$t('lang.k_341033'),
                    openShow: this.$t('lang.k_341034'),
                    closeShow: this.$t('lang.k_341035'),
                    value: 0
                  },
                  {
                    type: 'key_11',
                    key_name: this.$t('lang.k_341036'),
                    openShow: this.$t('lang.k_341037'),
                    closeShow: this.$t('lang.k_341037'),
                    value: 0
                  }
                ]
              },
              {
                title: this.$t('lang.k_341038'),
                list: [
                  {
                    type: 'key_4',
                    key_name: this.$t('lang.k_341039'),
                    openShow: this.$t('lang.k_341040'),
                    closeShow: this.$t('lang.k_341041'),
                    value: 0
                  },
                  {
                    type: 'key_8',
                    key_name: this.$t('lang.k_341042'),
                    openShow: this.$t('lang.k_341043'),
                    closeShow: this.$t('lang.k_341044'),
                    value: 0
                  },
                  {
                    type: 'key_5',
                    key_name: this.$t('lang.k_341045'),
                    openShow: this.$t('lang.k_341046'),
                    closeShow: this.$t('lang.k_341047'),
                    value: 0
                  },
                  {
                    type: 'key_6',
                    key_name: this.$t('lang.k_341048'),
                    openShow: this.$t('lang.k_341049'),
                    closeShow: this.$t('lang.k_341050'),
                    value: 0
                  },
                  {
                    type: 'key_9',
                    key_name: this.$t('lang.k_341051'),
                    openShow: this.$t('lang.k_341052'),
                    closeShow: this.$t('lang.k_341053'),
                    value: 0
                  }
                ]
              },
              {
                title: this.$t('lang.k_341054'),
                list: [
                  {
                    type: 'key_3',
                    key_name: this.$t('lang.k_341055'),
                    openShow: this.$t('lang.k_341056'),
                    closeShow: this.$t('lang.k_341057'),
                    value: 0
                  },
                  {
                    type: 'key_7',
                    key_name: this.$t('lang.k_341058'),
                    openShow: this.$t('lang.k_341059'),
                    closeShow: this.$t('lang.k_341060'),
                    value: 0
                  },
                  {
                    type: 'key_38',
                    key_name: this.$t('lang.k_341061'),
                    openShow: this.$t('lang.k_341062'),
                    closeShow: this.$t('lang.k_341063'),
                    value: 0
                  }
                ]
              },
              {
                title: this.$t('lang.k_341064'),
                list: [
                  {
                    type: 'key_15',
                    key_name: this.$t('lang.k_341065'),
                    openShow: this.$t('lang.k_341066'),
                    closeShow: this.$t('lang.k_341067'),
                    value: 0
                  }
                ]
              },
              {
                title: this.$t('lang.k_341068'),
                list: [
                  {
                    type: 'key_26',
                    key_name: this.$t('lang.k_341069'),
                    openShow: this.$t('lang.k_341070'),
                    closeShow: this.$t('lang.k_341071'),
                    value: 0
                  },
                  {
                    type: 'key_21',
                    key_name: this.$t('lang.k_341072'),
                    openShow: this.$t('lang.k_341073'),
                    closeShow: this.$t('lang.k_341074'),
                    value: 0
                  },
                  {
                    type: 'key_22',
                    key_name: this.$t('lang.k_341075'),
                    openShow: this.$t('lang.k_341076'),
                    closeShow: this.$t('lang.k_341077'),
                    value: 0
                  },
                  {
                    type: 'key_23',
                    key_name: this.$t('lang.k_341078'),
                    openShow: this.$t('lang.k_341079'),
                    closeShow: this.$t('lang.k_341080'),
                    value: 0
                  },
                  {
                    type: 'key_24',
                    key_name: this.$t('lang.k_341081'),
                    openShow: this.$t('lang.k_341082'),
                    closeShow: this.$t('lang.k_341083'),
                    value: 0
                  },
                  {
                    type: 'key_25',
                    key_name: this.$t('lang.k_341084'),
                    openShow: this.$t('lang.k_341085'),
                    closeShow: this.$t('lang.k_341086'),
                    value: 0
                  }
                ]
              },
              {
                title: this.$t('lang.k_341087'),
                list: [
                  {
                    type: 'key_30',
                    key_name: this.$t('lang.k_341088'),
                    openShow: this.$t('lang.k_341089'),
                    closeShow: this.$t('lang.k_341090'),
                    value: 0
                  }
                ]
              },
              {
                title: this.$t('lang.k_341091'),
                list: [
                  {
                    type: 'key_35',
                    key_name: this.$t('lang.k_341092'),
                    openShow: this.$t('lang.k_341093'),
                    closeShow: this.$t('lang.k_341094'),
                    value: 0,
                    k: 100867
                  },
                  {
                    type: 'key_3510',
                    key_name: this.$t('lang.k_341095'),
                    openShow: this.$t('lang.k_341096'),
                    closeShow: this.$t('lang.k_341097'),
                    value: 0,
                    k: 100868
                  },
                  {
                    type: 'key_3520',
                    key_name: this.$t('lang.k_341098'),
                    openShow: this.$t('lang.k_341099'),
                    closeShow: this.$t('lang.k_341100'),
                    value: 0,
                    k: 100869
                  },
                  {
                    type: 'key_3530',
                    key_name: this.$t('lang.k_341101'),
                    openShow: this.$t('lang.k_341102'),
                    closeShow: this.$t('lang.k_341103'),
                    value: 0,
                    k: 100870
                  },
                  {
                    type: 'key_3540',
                    key_name: this.$t('lang.k_341104'),
                    openShow: this.$t('lang.k_341105'),
                    closeShow: this.$t('lang.k_341106'),
                    value: 0,
                    k: 100871
                  },
                  {
                    type: 'key_3550',
                    key_name: this.$t('lang.k_341107'),
                    openShow: this.$t('lang.k_341108'),
                    closeShow: this.$t('lang.k_341109'),
                    value: 0,
                    k: 100872
                  }
                ]
              },
              {
                title: this.$t('lang.k_341110'),
                list: [
                  {
                    type: 'key_50',
                    key_name: this.$t('lang.k_341111'),
                    openShow: this.$t('lang.k_341112'),
                    closeShow: this.$t('lang.k_341113'),
                    value: 0
                  }
                ]
              },
              {
                title: this.$t('lang.k_341114'),
                list: [
                  {
                    type: 'key_60',
                    key_name: this.$t('lang.k_341115'),
                    openShow: this.$t('lang.k_341116'),
                    closeShow: this.$t('lang.k_341117'),
                    value: 0
                  },
                  {
                    type: 'key_61',
                    key_name: this.$t('lang.k_341118'),
                    openShow: this.$t('lang.k_341119'),
                    closeShow: this.$t('lang.k_341120'),
                    value: 0
                  },
                  {
                    type: 'key_65',
                    key_name: this.$t('lang.k_341121'),
                    openShow: this.$t('lang.k_341122'),
                    closeShow: this.$t('lang.k_341123'),
                    value: 0
                  }
                ]
              },
              {
                title: this.$t('lang.k_341124'),
                list: [
                  {
                    type: 'key_70',
                    key_name: this.$t('lang.k_341125'),
                    openShow: this.$t('lang.k_341126'),
                    closeShow: this.$t('lang.k_341127'),
                    value: 0
                  }
                ]
              },
              {
                title: this.$t('lang.k_341128'),
                list: [
                  {
                    type: 'key_80',
                    key_name: this.$t('lang.k_341129'),
                    openShow: this.$t('lang.k_341130'),
                    closeShow: this.$t('lang.k_341131'),
                    value: 0
                  }
                ]
              }
            ];

            if (this.$store.state.permissionValue['im_join_leave_msg_callback'] == 1) {
              this.keyList.push({
                title: this.$t('lang.k_341132'),
                list: [
                  {
                    type: 'key_20',
                    key_name: this.$t('lang.k_341133'),
                    openShow: this.$t('lang.k_341134'),
                    closeShow: this.$t('lang.k_341135'),
                    value: 0
                  }
                ]
              });
            }
          });
      },
      saveCallbackInfo() {
        console.log(this.keyList);
        let numKeys = [];
        this.keyList.forEach(item => {
          item.list.forEach(el => {
            if (Number(el.value) === 1) {
              numKeys.push(el.type.substring(4));
            }
          });
        });
        this.$refs.form.validate(valid => {
          if (valid) {
            let callback_event = '';
            let params = {
              secret_key: this.form.secret_key,
              callback_url: this.form.callback_url,
              callback_event: numKeys.join(','),
              fail_try_request: this.form.fail_try_request,
              msg_type: this.form.msg_type
            };
            this.$fetch(this.isAdd ? 'addCallbackInfo' : 'editCallbackInfo', params)
              .then(res => {
                this.setReportData(this.keyList);
                this.$vhMessage({
                  message: `${this.$t('lang.k_341136')}`,
                  showClose: true,
                  // duration: 0,
                  type: 'success',
                  customClass: 'zdy-info-box'
                });
                // 数据刷新
                this.getCallbackInfo();
              })
              .catch(res => {
                this.$vhMessage({
                  message: res.msg || `${this.$t('lang.k_341137')}`,
                  showClose: true,
                  // duration: 0,
                  type: 'error',
                  customClass: 'zdy-info-box'
                });
              });
          }
        });
      },
      setReportData(list) {
        this.$vhall_paas_port({
          k: 100596,
          data: {
            business_uid: this.userId,
            user_id: '',
            s: '',
            webinar_id: '',
            refer: '',
            report_extra: {},
            ref_url: '',
            req_url: ''
          }
        });
        this.$vhall_paas_port({
          k: this.form.msg_type == 1 ? 100597 : 100598,
          data: {
            business_uid: this.userId,
            user_id: '',
            s: '',
            webinar_id: '',
            refer: '',
            report_extra: {},
            ref_url: '',
            req_url: ''
          }
        });
        this.$vhall_paas_port({
          k: this.form.fail_try_request == 1 ? 100599 : 100600,
          data: {
            business_uid: this.userId,
            user_id: '',
            s: '',
            webinar_id: '',
            refer: '',
            report_extra: {},
            ref_url: '',
            req_url: ''
          }
        });
        list.map(item => {
          this.$vhall_paas_port({
            k: item.value == 1 ? item.k : item.k + 1,
            data: {
              business_uid: this.userId,
              user_id: '',
              s: '',
              webinar_id: '',
              refer: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
        });
      },
      // 设置是否展示提示
      setIsShowTip() {
        const userInfo = JSON.parse(sessionOrLocal.get('userInfo'));
        console.log('userInfo>>>>', userInfo);
        // 子账号
        if (userInfo.parent_id > 0) {
          this.isShowTip = true;
        }
      }
    }
  };
</script>

<style lang="less" scoped>
  .title-callback {
    &-tip {
      font-size: 14px;
      color: #999;
    }
    .titleBox {
      float: left;
    }
    a {
      float: right;
      font-size: 14px;
      font-weight: 400;
      color: #3562fa;
      line-height: 20px;
    }
  }
  .layout-callback {
    clear: both;
    .vh-form {
      ::v-deep .vh-input {
        width: 640px;
      }
      ::v-deep .vh-form-item {
        margin-bottom: 24px;
        &.callback-btn {
          margin-bottom: 0;
        }
        &.radio-btn {
          margin-bottom: 12px;
        }
      }
    }
    .layout--right--main();
    .padding48-40();
    .cate_card {
      margin-bottom: 30px;
      .cate_name {
        line-height: 40px;
        font-weight: 600;
        font-size: 16px;
        color: #333;
      }
    }
  }

  .page-padding {
    padding: 0 0;
  }
  .h1__title {
    margin-bottom: 32px;
  }
  .div__view {
    margin-bottom: 12px;
  }
  .div__func {
    min-height: 190px;
    background: @background_white;
    border-radius: 4px;
    margin: 0 auto 40px auto;
  }
  .div__view__title {
    margin-left: 24px;
    font-size: @font_size_16;
    font-weight: 400;
    color: @font_color_h1;
    line-height: 22px;
  }
  .switch__list {
    li {
      display: block;
      list-style-type: none;
      margin-bottom: 12px;
      line-height: 40px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .leve3_title {
    display: inline-block;
    text-align: right;
    min-width: 100px;
    &.title--999 {
      margin-left: 8px;
    }
  }

  .saasicon_help_m {
    color: #999999;
  }
</style>
